<template>
    <div class="detail">
        <template v-if="isLoaded">
            <div class="container">
                <div class="top">
                    <div class="name">{{data.project_name}}</div>
                    <img class="logo" :src="data.logo" alt=""/>
                </div>
                <div class="detail">
                    <div class="left">
                        <div class="detail_swiper_wrap">
                            <DetailSwiper :data="data.banner"/>
                            <div class="form_btn" @click="showForm = true">预约参观</div>
                        </div>
                        <div class="floor_cover" :style="`background-image: url(${data.floor_image});`">
                            <img :src="data.floor_image" alt="" preview="floor_mobile"/>
                        </div>
                        <div class="content_title">{{data.name}}</div>
                        <div class="text_group">
                            <div class="item">
                                <p><b>{{data.area_price}}</b></p>
                                <p>平方米/天</p>
                            </div>
                            <div class="item">
                                <p><b>{{data.people_num}}</b></p>
                                <p>工位约容纳</p>
                            </div>
                            <div class="item">
                                <p><b>{{data.standard_delivery}}</b></p>
                                <p>装修程度</p>
                            </div>
                        </div>
                        <div class="floor_info">
                            <div class="text">
                                <div class="title">概况：</div>
                                <p>可注册：{{data.register}}</p>
                                <p>最早可租：{{data.earliest_rentable}}</p>
                                <p>装修情况：{{data.decoration}}</p>
                                <p>免租时间：{{data.rent_free_time}}</p>
                                <p>最短租期：{{data.minimum_lease_term}}</p>
                                <a class="btn" v-if="data.vr_link" :href="data.vr_link">VR看房</a>
                            </div>
                            <img :src="data.floor_image" alt="" class="cover" preview='floor_pc'/>
                        </div>
                        <div class="location">
                            <div class="content_title">区域交通</div>
                            <div class="map_wrap">
                                <!-- <BaiduMap class="map" 
                                ak="zCiFCB9vLfOLVw3gRerBY6x9G9lvenY0"
                                :center="mapOption.center"
                                :zoom="mapOption.zoom"
                                :scroll-wheel-zoom="true"
                                :map-click="false"
                                @ready="mapReady">
                                    <BmMarker :position="mapOption.center"/>
                                    <template v-if="mapOption.icon.url">
                                        <BmMarker :position="mapOption.center" :icon="mapOption.icon"/>
                                    </template>
                                </BaiduMap> -->
                                <div class="desc">
                                    <div class="item">
                                        <div class="title">具体位置：</div>
                                        <div class="text">{{data.traffic.address}}</div>
                                        <div class="text" v-for="(item, index) in data.traffic.subway_line" :key="index" v-html="subway(item.name)"></div>
                                    </div>
                                    <div class="item">
                                        <div class="title">周边环境：</div>
                                        <div class="text">{{data.traffic.environment}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="form">
                            <div class="title">预约参观</div>
                            <p>我们将尽快与您联系请填写以下信息</p>
                            <input type="text" placeholder="姓名" v-model="form.name"/>
                            <input type="tel" placeholder="电话" v-model="form.phone" maxlength="11"/>
                            <p>请填写您的留言</p>
                            <textarea v-model="form.content"></textarea>
                            <div class="btn" :class="{live: formBtnLive()}" @click="upForm">提交</div>
                            <div class="tel">租赁热线：{{data.banner_phone}}</div>
                            <div class="checkbox_wrap">
                                <input type="checkbox" v-model="isChecked"/>
                                <p>查看并同意<router-link target="_blank" to="/privacy">《隐私条款》</router-link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- form -->
            <div class="popup" :class="{active: showForm}">
                <div class="close" @click="showForm = false"></div>
                <div class="btn_close" @click="showForm = false"></div>
                <div class="in">
                    <img :src="data.logo" alt="" class="logo">
                    <p class="title">预约参观</p>
                    <p>我们将尽快与您联系请填写以下信息</p>
                    <input type="text" placeholder="姓名" v-model="form.name"/>
                    <input type="tel" placeholder="电话" v-model="form.phone" maxlength="11"/>
                    <p>请填写您的留言</p>
                    <textarea v-model="form.content"></textarea>
                    <div class="btn" :class="{live: formBtnLive()}" @click="upForm">立即加入</div>
                    <div class="tel">租赁热线：{{data.banner_phone}}</div>
                    <div class="checkbox_wrap">
                        <input type="checkbox" v-model="isChecked"/>
                        <p>查看并同意<router-link target="_blank" to="/privacy">《隐私条款》</router-link></p>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
// import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
// import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import DetailSwiper from '../../components/detailSwiper.vue';
import config from '../../config';
export default {
    name: "detail",
    data() {
        return {
            isLoaded: false,
            showForm: false,
            isChecked: true,
            form: {
                name: '',
                phone: '',
                content: ''
            },
            data: {
                traffic: {
                    address: '',
                    subway_line: [],
                    environment: ''
                }
            },
            mapOption: {
                center: {lng: 0, lat: 0},
                zoom: 15,
                icon: {
                    url: '',
                    size: {width: 172, height: 65}
                }
            },
        };
    },
    computed: {
        formBtnLive(){
            return (payload)=>{
                if(this.form.name.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                    if(payload) self.$showToast({ text: '姓名不能为空' })
                    return false;
                }
                if(this.form.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                    if(payload) self.$showToast({ text: '手机号码不能为空' })
                    return false;
                }
                if(!(/^1[3-9]\d{9}$/.test(this.form.phone))){
                    if(payload) self.$showToast({ text: '手机号码格式有误' })
                    return false;
                }
                if(this.form.content.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                    if(payload) self.$showToast({ text: '留言不能为空' })
                    return false;
                }
                if(!this.isChecked){
                    if(payload) this.$showToast({ text: '请查看并同意隐私条款' })
                    return false;
                }
                return true;
            }
        },
        subway(){
            return (text)=>{
                text = text.replace(/([0-9]*)号线/, '<span class="icon" data-index="$1">$1</span>号线')
                return text;
            };
        },
    },
    components: {
        DetailSwiper,
        // BaiduMap,
        // BmMarker,
    },
    mounted() {
        this.getData();
    },
    watch: {
        $route(){
            this.$router.go(0)
        }
    },
    methods: {
        upForm(){
            let self = this;
            if(!this.formBtnLive(true)){
                return false;
            }
            this.$showLoading();
            this.axios.get(config.message, {
                params: {
                    id: this.$route.query.id,
                    name: this.form.name,
                    phone: this.form.phone,
                    content: this.form.content,
                }
            }).then((result) => {
                self.$hideLoading();
                if(result.data.code == 100){
                    self.$showToast({ text: '提交成功' })
                    self.form = {
                        name: '',
                        phone: '',
                        content: '',
                    }
                }else{
                    self.$showToast({ text: '提交失败' })
                }
            }).catch((err) => {
                self.$hideLoading();
                self.$showToast({ text: '提交失败' })
            });
        },
        mapReady(){
            this.mapOption.center.lat = this.data.traffic.lat;
            this.mapOption.center.lng = this.data.traffic.lon;
            // this.mapOption.icon.url = this.data.traffic.map_logo;
        },
        getData(){
            let self = this;
            this.axios.get(config.floor, {
                params: {
                    lang: localStorage.getItem('locale'),
                    id: this.$route.params.id
                }
            })
            .then((result) => {
                if (result.data.code == 100) {
                    self.isLoaded = true;
                    self.data = result.data.data;
                    
                    self.mapOption.center.lat = self.data.traffic.lat;
                    self.mapOption.center.lng = self.data.traffic.lon;
                    self.mapOption.icon.url = self.data.traffic.map_logo;
                }
            }).catch((err) => {
                
            });
        },
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.detail{
    display: flex;
    .left{
        width: 8.4rem;
    }
    .right{
        flex: 1;
        margin-left: .1rem;
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        padding-top: 1rem;
        .left{
            width: 100%;
        }
        .right{
            display: none;
        }
    }
}
.content_title{
    font-size: .26rem;
    margin-bottom: .3rem;
    @media only screen and (max-width: 1200px) {
        font-size: .72rem;
        text-align: center;
        margin: 0;
        padding: 1.2rem 0 1rem;
    }
}
.form{
    position: sticky;
    top: 1.1rem;
    left: 0;
    border-radius: .04rem;
    padding: .3rem;
    border: 1px solid #e6e6e6;
    .title{
        font-size: .26rem;
        margin-bottom: .1rem;
    }
    input,
    textarea{
        width: 100%;
        display: block;
        background: none;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-radius: .04rem;
        margin: .1rem 0 .15rem;
        outline: none;
        font-size: .16rem;
    }
    input{
        height: .3rem;
        padding: 0 .1rem;
        ::placeholder{
            color: rgba($color: #000000, $alpha: .5);
        }
    }
    textarea{
        height: .5rem;
        resize: none;
        padding: .06rem .1rem;
        font-family: Arial, Helvetica, sans-serif;
    }
    .btn{
        height: .3rem;
        background: #7b7b7b;
        border-radius: .04rem;
        text-align: center;
        line-height: .3rem;
        cursor: pointer;
        margin: .2rem 0 .1rem;
        color: #fff;
        &.live{
            background: #ff4028;
        }
    }
    .tel{
        display: flex;
        align-items: center;
        &::before{
            content: "";
            display: block;
            width: .21rem;
            height: .21rem;
            background: url('~@/assets/images/icon_tel2.png') no-repeat 0/100%;
            margin-right: .05rem;
        }
    }
    .checkbox_wrap{
        display: flex;
        align-items: center;
        input[type=checkbox]{
            width: .2rem;
            height: .2rem;
            border: 1px solid #000;
            border-radius: .05rem;
            margin-right: .05rem;
        }
        a{
            text-decoration: underline;
        }
    }
}
.top{
    width: 8.4rem;
    padding-top: .3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: .1rem;
    @media only screen and (max-width: 1200px) {
        display: none;
    }
    .name{
        font-size: .26rem;
    }
    .logo{
        width: 1.2rem;
    }
}
.detail_swiper_wrap{
    margin-bottom: .5rem;
    .form_btn{
        display: none;
    }
    @media only screen and (max-width: 1200px) {
        margin-bottom: 0;
        .form_btn{
            width: 10.44rem;
            height: 1.1rem;
            border-radius: .2rem;
            background: #7b7b7b;
            font-size: .48rem;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: .45rem auto 1rem;
        }
    }
}
.text_group{
    display: flex;
    font-size: .2rem;
    margin-bottom: .5rem;
    .item{
        margin-right: .5rem;
        text-align: center;
    }
    @media only screen and (max-width: 1200px) {
        justify-content: space-between;
        padding: 0 1rem;
        font-size: .48rem;
        margin-bottom: 1rem;
    }
}
.floor_cover{
    display: none;
    @media only screen and (max-width: 1200px) {
        display: block;
        width: 10.45rem;
        height: 9.35rem;
        border: 1px solid #cecece;
        border-radius: .04rem;
        background: no-repeat center/cover;
        box-shadow: 0 0 .3rem .05rem rgba($color: #000000, $alpha: .2);
        margin: 0 auto;
        img{
            width: 100%;
            height: 100%;
            opacity: 0;
        }
    }
}
.floor_info{
    display: flex;
    align-items: center;
    margin-bottom: .5rem;
    .cover{
        width: 3.48rem;
        cursor: pointer;
    }
    .text{
        flex: 1;
        .title{
            font-size: .26rem;
            margin-bottom: 0.3rem;
        }
        p{
            margin-bottom: .3rem;
        }
        .btn{
            width: 1rem;
            height: .4rem;
            border-radius: .04rem;
            background: #7b7b7b;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;

        }
    }
    @media only screen and (max-width: 1200px) {
        margin-bottom: 0;
        .cover{
            display: none;
        }
        .text{
            font-size: .48rem;
            padding: 0 1rem;
            .title{
                font-size: .6rem;
            }
            .btn{
                width: 2.7rem;
                height: .84rem;
                margin: 1rem auto 0;
                font-size: .36rem;
            }
        }
    }
}
.location{
    padding-bottom: .8rem;
    .map_wrap{
        background: #e6e6e6;
        .map{
            width: 100%;
            height: 3.6rem;
            /deep/.BMap_Marker{
                pointer-events: none;
                div{
                    transform: translate3d(0,100%,0);
                }
            }
        }
        .desc{
            flex: 1;
            padding: .2rem .35rem;
            line-height: 1.8;
            display: flex;
            .item{
                flex: 1;
            }
            .title{
                font-weight: bold;
                margin-top: .1rem;
                &:first-child{
                    margin-top: 0;
                }
            }
            .text{
                /deep/.icon{
                    width: .2rem;
                    height: .2rem;
                    display: inline-block;
                    border-radius: 50%;
                    line-height: .2rem;
                    text-align: center;
                    margin-right: .05rem;
                    font-size: .14rem;
                    color: #fff;
                    &[data-index="1"]{
                        background: rgb(234,27,57);
                    }
                    &[data-index="2"]{
                        background: rgb(139,196,63);
                    }
                    &[data-index="3"]{
                        background: rgb(251,210,8);
                    }
                    &[data-index="4"]{
                        background: rgb(81,45,141);
                    }
                    &[data-index="5"]{
                        background: rgb(144,86,163);
                    }
                    &[data-index="6"]{
                        background: rgb(214,24,112);
                    }
                    &[data-index="7"]{
                        background: rgb(244,113,33);
                    }
                    &[data-index="8"]{
                        background: rgb(0,158,219);
                    }
                    &[data-index="9"]{
                        background: rgb(121,201,238);
                    }
                    &[data-index="10"]{
                        background: rgb(189,168,211);
                    }
                    &[data-index="11"]{
                        background: rgb(127,33,49);
                    }
                    &[data-index="12"]{
                        background: rgb(1,124,103);
                    }
                    &[data-index="13"]{
                        background: rgb(232,149,193);
                    }
                    &[data-index="14"]{
                        background: rgb(94,92,41);
                    }
                    &[data-index="15"]{
                        background: rgb(187,167,134);
                    }
                    &[data-index="16"]{
                        background: rgb(142,209,192);
                    }
                    &[data-index="17"]{
                        background: rgb(184,121,116);
                    }
                    &[data-index="18"]{
                        background: rgb(186,160,81);
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        padding-bottom: 0;
        margin-bottom: 1.2rem;
        .map_wrap{
            flex-direction: column-reverse;
            .map{
                width: 100%;
                height: 8.7rem;
            }
            .desc{
                padding: 1rem;
                font-size: .48rem;
                display: block;
                .item{
                    margin-top: .6rem;
                    &:first-child{
                        margin-top: 0;
                    }
                }
                .title{
                    font-size: .56rem;
                }
                .text{
                    /deep/.icon{
                        width: .72rem;
                        height: .72rem;
                        font-size: .48rem;
                        line-height: .72rem;
                    }
                }
            }
        }
    }
}
.popup{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: .5);
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    transition: opacity .5s, visibility .5s;
    &.active{
        opacity: 1;
        visibility: visible;
    }
    .close{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .in{
        width: 3.6rem;
        padding: .3rem;
        border-radius: .04rem;
        background: #fff;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .logo{
            width: 1.2rem;
            margin: 0 auto .2rem;
        }
        input,
        textarea{
            width: 100%;
            display: block;
            background: none;
            box-sizing: border-box;
            border: 1px solid #f2f2f2;
            border-radius: .04rem;
            margin: .1rem 0 .15rem;
            outline: none;
        }
        input{
            height: .3rem;
            padding: 0 .1rem;
            ::placeholder{
                color: rgba($color: #000000, $alpha: .5);
            }
        }
        textarea{
            height: .5rem;
            resize: none;
            padding: .06rem .1rem;
            font-family: Arial, Helvetica, sans-serif;
        }
        .btn{
            height: .3rem;
            background: #7b7b7b;
            border-radius: .04rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin: .2rem 0 .1rem;
            color: #fff;
            &.live{
                background: #ff4028;
            }
        }
        .tel{
            display: flex;
            align-items: center;
            &::before{
                content: "";
                display: block;
                width: .21rem;
                height: .21rem;
                background: url('~@/assets/images/icon_tel2.png') no-repeat 0/100%;
                margin-right: .05rem;
            }
        }
        .checkbox_wrap{
            display: flex;
            align-items: center;
            input[type=checkbox]{
                width: .2rem;
                height: .2rem;
                border: 1px solid #000;
                border-radius: .05rem;
                margin-right: .05rem;
            }
            a{
                text-decoration: underline;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        .close{
            display: none;
        }
        .btn_close{
            width: .8rem;
            height: .8rem;
            position: absolute;
            top: 1rem;
            right: 1rem;
            z-index: 1;
            &::before,
            &::after{
                content: "";
                width: 100%;
                height: .1rem;
                display: block;
                background: #e1442b;
                border-radius: .1rem;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        .in{
            width: 100%;
            height: 100%;
            padding: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: .48rem;
            .logo{
                width: 5.5rem;
                margin-bottom: 1.3rem;
            }
            .title{
                font-size: 1rem;
                font-weight: bold;
                text-align: center;
                margin: 0 0 .8rem;
            }
            p{
                margin: .25rem 0;
            }
            input,
            textarea{
                width: 9rem;
                border-width: .03rem;
                border-radius: .2rem;
                margin: .25rem 0;
                font-size: .48rem;
            }
            input{
                height: .93rem;
                padding: 0 .2rem;
            }
            textarea{
                height: 3.06rem;
                padding: .2rem;
                margin-bottom: 1.1rem;
            }
            .btn{
                width: 8.88rem;
                height: .96rem;
                border-radius: .2rem;
                margin: 0 0 .7rem;
            }
            .tel{
                &::before{
                    width: .5rem;
                    height: .5rem;
                    margin-right: .2rem;
                }
            }
            .checkbox_wrap{
                input[type=checkbox]{
                    width: .5rem;
                    height: .5rem;
                    border-radius: .1rem;
                    margin-right: .2rem;
                }
            }
        }
    }
}
</style>